import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useDebounce } from "@vueuse/core";
import { BButton, BFormCheckbox, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { computed, reactive, ref } from "vue";
import { getAppRoot } from "@/onload/loadConfig";
import { copy } from "@/utils/clipboard";
import ZoomControl from "@/components/Workflow/Editor/ZoomControl.vue";
import WorkflowPublished from "@/components/Workflow/Published/WorkflowPublished.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowEmbed',
    props: {
        id: null
    },
    setup(__props) {
        const props = __props;
        library.add(faCopy);
        const settings = reactive({
            buttons: true,
            about: false,
            heading: false,
            minimap: true,
            zoomControls: true,
            initialX: -20,
            initialY: -20,
            zoom: 1,
            applyStyle: true,
        });
        function onChangePosition(event, xy) {
            const value = parseInt(event.target.value);
            if (xy === "x") {
                settings.initialX = value;
            }
            else {
                settings.initialY = value;
            }
        }
        const root = computed(() => {
            const port = window.location.port ? `:${window.location.port}` : "";
            return `${window.location.protocol}//${window.location.hostname}${port}${getAppRoot()}`;
        });
        const embedUrl = computed(() => {
            let url = `${root.value}published/workflow?id=${props.id}&embed=true`;
            url += `&buttons=${settings.buttons}`;
            url += `&about=${settings.about}`;
            url += `&heading=${settings.heading}`;
            url += `&minimap=${settings.minimap}`;
            url += `&zoom_controls=${settings.zoomControls}`;
            url += `&initialX=${settings.initialX}&initialY=${settings.initialY}`;
            url += `&zoom=${settings.zoom}`;
            return url;
        });
        const embedStyle = computed(() => {
            if (settings.applyStyle) {
                return ' style="width: 100%; height: 700px; border: none;" ';
            }
            else {
                return " ";
            }
        });
        const embed = computed(() => `<iframe title="Galaxy Workflow Embed"${embedStyle.value}src="${embedUrl.value}"></iframe>`);
        // These Embed settings are not reactive, to we have to key them
        const embedKey = computed(() => `zoom: ${settings.zoom}, x: ${settings.initialX}, y: ${settings.initialY}`);
        const debouncedEmbedKey = useDebounce(embedKey, 500);
        const showEmbed = ref(false);
        const showEmbedDebounced = useDebounce(showEmbed, 100);
        const copied = ref(false);
        function onCopy() {
            copy(embed.value);
            copied.value = true;
        }
        function onCopyOut() {
            copied.value = false;
        }
        const clipboardTitle = computed(() => (copied.value ? "Copied!" : "Copy URL"));
        return { __sfc: true, props, settings, onChangePosition, root, embedUrl, embedStyle, embed, embedKey, debouncedEmbedKey, showEmbed, showEmbedDebounced, copied, onCopy, onCopyOut, clipboardTitle, FontAwesomeIcon, BButton, BFormCheckbox, BFormInput, BInputGroup, BInputGroupAppend, ZoomControl, WorkflowPublished };
    }
});
